import { render, staticRenderFns } from "./SubOrder.vue?vue&type=template&id=1620c692&scoped=true"
import script from "./SubOrder.vue?vue&type=script&lang=js"
export * from "./SubOrder.vue?vue&type=script&lang=js"
import style0 from "./SubOrder.vue?vue&type=style&index=0&id=1620c692&prod&scoped=true&lang=css"
import style1 from "./SubOrder.vue?vue&type=style&index=1&id=1620c692&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1620c692",
  null
  
)

export default component.exports